import { SvgIcon, SvgIconProps } from "@commonlibs";
import clsx from "clsx";

export default function FileIcon({ className, ...rest }: Omit<SvgIconProps, "children">): JSX.Element {
    return (
        <SvgIcon {...rest} data-testid="FileIcon" className={clsx(undefined, "Icon", className)} fill="none">
            <path
                id="Trazado_1821"
                d="M66.333,677.923A1.923,1.923,0,0,1,68.256,676h7.692a.96.96,0,0,1,.68.282l4.808,4.808a.96.96,0,0,1,.282.68v11.538a1.923,1.923,0,0,1-1.923,1.923H68.256a1.923,1.923,0,0,1-1.923-1.923ZM79.4,681.769l-3.448-3.448v3.448Zm-5.371-3.846H68.256v15.385H79.795v-9.615H74.987a.962.962,0,0,1-.962-.962ZM77.59,685.9a.961.961,0,0,1,0,1.359L73.744,691.1a.961.961,0,0,1-1.36,0l-1.923-1.923a.961.961,0,0,1,1.36-1.359l1.243,1.243L76.23,685.9A.96.96,0,0,1,77.59,685.9Z"
                transform="translate(-66.333 -676)"
                fill="#e6ba0e"
            />
        </SvgIcon>
    );
}
